import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../../Common/ies-http-client.service';
import { AppUrl } from '../../../Common/appUrl';

@Injectable()
export class AdmUpdateProctorTeamLeadService {

  constructor(private _httpClient: IesHttpClient) {
  }

  // Fetch data by proctor Id
  getDataById(id: number) {
    return this._httpClient.get(AppUrl.getProctorDataById, id);
  }

  //Save, Update proctor lead
  saveData(params: any) {
    return this._httpClient.post(AppUrl.saveProctorData, params);
  }

  /**
   * Update proctor status : Active or Retire
   * @param params 
   */

  updateStatus(params: any) {
    return this._httpClient.post(AppUrl.updateProctorStatus, params);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-update-proctor-team-lead/adm-update-proctor-team-lead.service.ts